import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMicroscope, faHeart, faGlobe, faHandshake } from '@fortawesome/free-solid-svg-icons';
import '../styles/OurVision.css';

const OurVision = () => {
  return (
    <main className="container">
      <h1 className="text">Our Vision</h1>
      <div className="grid ">
        {/* Card 1 */}
        <div className="card">
          <FontAwesomeIcon icon={faMicroscope} className="text-4xl mb-4" />
          <h2 className="text-2xl font-bold mb-4">Research Excellence</h2>
          <p>Pioneering innovative pharmaceutical solutions through cutting-edge research and development.</p>
        </div>

        {/* Card 2 */}
        <div className="card">
          <FontAwesomeIcon icon={faHeart} className="text-4xl " />
          <h2 className="text-2xl font-bold mb-4">Patient Care</h2>
          <p>Prioritizing patient well-being through quality healthcare solutions and accessible medicine.</p>
        </div>

        {/* Card 3 */}
        <div className="card">
          <FontAwesomeIcon icon={faGlobe} className="text-4xl " />
          <h2 className="text-2xl font-bold mb-4">Global Impact</h2>
          <p>Expanding our reach to serve communities worldwide with affordable healthcare solutions.</p>
        </div>

        {/* Card 4 */}
        <div className="card">
          <FontAwesomeIcon icon={faHandshake} className="text-4xl mb-4" />
          <h2 className="text-2xl font-bold mb-4">Ethical Leadership</h2>
          <p>Maintaining highest standards of integrity and ethical practices in pharmaceutical development.</p>
        </div>
      </div>
    </main>
  );
};

export default OurVision;